export default {
      id: "launch-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#launch-usage",
      toString: function () {
        return this.url;
      }
    }